export default "__VITE_ASSET__LHl16$Wc__"